import { render, staticRenderFns } from "./service-details.vue?vue&type=template&id=618afd89&scoped=true"
import script from "./service-details.vue?vue&type=script&lang=js"
export * from "./service-details.vue?vue&type=script&lang=js"
import style0 from "./service-details.vue?vue&type=style&index=0&id=618afd89&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618afd89",
  null
  
)

export default component.exports